import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useStaticQuery, graphql, Link } from "gatsby"
import { Helmet } from "react-helmet";
import { isMobile, isDesktop } from "react-device-detect"
import loadable from '@loadable/component';

import PopularSearch from "gatsby-theme-starberry-lomondgroup/src/components/Footer/Sections/PopularSearch"
import PopularSearch_Dynamic from "gatsby-theme-starberry-lomondgroup/src/components/Footer/Sections/PopularSearchDynamic"
import FooterMenu from "gatsby-theme-starberry-lomondgroup/src/components/Footer/Sections/FooterMenu"
import FooterSubscribe from "gatsby-theme-starberry-lomondgroup/src/components/Footer/Sections/FooterSubscribe"
import ClientLogo from "gatsby-theme-starberry-lomondgroup/src/components/Footer/Sections/ClientLogo"
import SocialLinks from "gatsby-theme-starberry-lomondgroup/src/components/Footer/Sections/SocialLinks"
import FooterLinks from "gatsby-theme-starberry-lomondgroup/src/components/Footer/Sections/FooterLinks"
import FooterText from "gatsby-theme-starberry-lomondgroup/src/components/Footer/Sections/FooterText"
//import YunoWidget from "gatsby-theme-starberry-lomondgroup/src/components/Footer/Sections/YunoWidget"

import ComplianceLogo from "gatsby-theme-starberry-lomondgroup/src/components/Footer/Sections/ComplianceLogo"

//import ImageModule from "../../modules/image_module";
import { PageLinks } from "gatsby-theme-starberry-lomondgroup/src/common/page-links";
import { RenderComponent } from "gatsby-theme-starberry-lomondgroup/src/modules/render-component";
import STB_Logo from "gatsby-theme-starberry-lomondgroup/src/images/sb-logo-footer.svg";

// import CookieConsent from "react-cookie-consent"

import "gatsby-theme-starberry-lomondgroup/src/components/Footer/Footer.scss";
import 'gatsby-theme-starberry-lomondgroup/src/scss/cookie-popup.scss'

const ImageModule = loadable(() => import("gatsby-theme-starberry-lomondgroup/src/modules/image_module"))
//const { YomdelChatScript } = require("@starberry/react-chat-widgets/Yomdel/Chat")
const { YomdelChatScript } = loadable(() => require("@starberry/react-chat-widgets/Yomdel/Chat"))


const handleCookiesClick = () => {
    if (typeof window === 'undefined') return;

    // If already initialised, open immediately
    if (window.OneTrust) {
        window.OneTrust.ToggleInfoDisplay();
        return;
    }

    const otId = process.env.GATSBY_ONETRUST_ID;
    if (!otId) return;

    // Inject the SDK stub if it hasn't been added yet
    if (!document.querySelector('script[data-domain-script="' + otId + '"]')) {
        const s = document.createElement('script');
        s.charset = 'UTF-8';
        s.setAttribute('data-domain-script', otId);
        s.src = 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js';
        document.head.appendChild(s);
    }

    // Poll every 100ms until window.OneTrust is ready (max 8 seconds)
    const started = Date.now();
    const poll = () => {
        if (window.OneTrust) {
            window.OneTrust.ToggleInfoDisplay();
        } else if (Date.now() - started < 8000) {
            setTimeout(poll, 100);
        }
    };
    setTimeout(poll, 100);
};


const Footer = (props) => {
    const renderComponent = RenderComponent()

    const data = useStaticQuery(graphql`
    query FooterQueryCustom{
        glstrapi {

            socialLink {
                footer_menu {
                    title
                    id
                    footer_links {
                        custom_link
                        label
                        id
                        link_type
                        target
                        menu_item {
                            slug
                            parent {
                                slug
                                parent {
                                    slug
                                }
                            }
                        }
                    }
                }
            }

            siteConfig {
                linkedin_link
                instagram_link
                facebook_link
                pinterest_link
                twitter_link
                youtube_link
                tiktok_link

                news_letter {
                    title
                    form_bottom_content
                    content
                }

                Header_Bg_White_Logo {
                    url
                    alternativeText
                }
                Student_hub_logo {
                    alternativeText
                    url
                }
                Header_Logo {
                    url
                    alternativeText
                }

                footer_links {
                    id
                    menu_link {
                        target
                        label
                        link_type
                        custom_link
                        id
                        menu_item {
                            slug
                            parent {
                                slug
                                parent {
                                    slug
                                }
                            }
                        }
                    }
                }

                Footer_Logo {
                    url
                    alternativeText
                    width
                    height
                }
            }

            clientLogo {
                show_on_website
                client_logos {
                    client_logo {
                        url
                        alternativeText
                        width
                        height
                    }
                    link
                }
            }

        }
    }`)

    var footer_data = data?.glstrapi;
    var siteData = footer_data?.siteConfig;

    //console.log("get_cookie", getCookieConsentValue());

    var schemaSameAs = ''
    if (siteData?.facebook_link?.length > 1) {
        schemaSameAs = siteData?.facebook_link + ','
    }
    if (siteData?.twitter_link?.length > 1) {
        schemaSameAs += siteData?.twitter_link + ','
    }
    if (siteData?.instagram_link?.length > 1) {
        schemaSameAs += siteData?.instagram_link + ','
    }
    if (siteData?.linkedin_link?.length > 1) {
        schemaSameAs += siteData?.linkedin_link + ','
    }
    if (siteData?.youtube_link?.length > 1) {
        schemaSameAs += siteData?.youtube_link + ','
    }
    if (siteData?.pinterest_link?.length > 1) {
        schemaSameAs += siteData?.pinterest_link + ','
    }

    var ldJson = '';

    if (props.menu_slug === "home") {
        if (process.env.GATSBY_SITE_NAME === "Matthews of Chester") {
            ldJson = `{
            "@context": "https://schema.org",
            "@type": "Organization",
            "url": "${process.env.GATSBY_SITE_URL}",
            "name": "${process.env.GATSBY_SITE_NAME}",
            "alternateName": "${process.env.GATSBY_SITE_NAME}  ${props?.seo_meta?.title ? props?.seo_meta?.title : ``}",
            "logo": "${process.env.GATSBY_SITE_URL}/images/mail-logo.png",       
            "sameAs": "${schemaSameAs.replace(/,\s*$/, "").split(',')}"
        }`

        } else {
            ldJson = `{
            "@context": "https://schema.org",
            "@type": "Organization",
            "url": "${process.env.GATSBY_SITE_URL}",
            "name": "${process.env.GATSBY_SITE_NAME}",
            "alternateName": "${process.env.GATSBY_SITE_NAME}  ${props?.seo_meta?.title ? props?.seo_meta?.title : ``}",
            "logo": "${process.env.GATSBY_SITE_URL}/images/mail-logo.png",
            "aggregateRating": 
            {
              "@type": "AggregateRating",
              "ratingValue": "4.9",
              "reviewCount": "5"
            },        
            "sameAs": "${schemaSameAs.replace(/,\s*$/, "").split(',')}"
        }`
        }

    }

    if (PageLinks.about === props?.menu_slug) {
        ldJson = `{
        "@context": "https://schema.org",
        "@type": "RealEstateAgent",
        "url": "${process.env.GATSBY_SITE_URL}/${PageLinks.about}/",
        "name": "${process.env.GATSBY_SITE_NAME}",
        "image": "${props.GQLPage?.banner_section?.banner_image.url}",
        "logo": "${process.env.GATSBY_SITE_URL}/images/mail-logo.png"
        }`
    }


    //console.log("menu_slug", props.menu_slug, PageLinks.about);

    return (
        <React.Fragment>
            <Helmet>
                <script type="application/ld+json">{ldJson}</script>
            </Helmet>

            {/* <YunoWidget /> */}


            <footer className={`footer ${props.isJourneySec ? "journey_section" : ""} ${props.footerCls}`}>
                <Container>
                    <Row>
                        <Col>
                            <div className="footer-wrapper">

                                <div className="footer-icon-wrap">
                                    <div className="brand-logo">
                                        {process.env.GATSBY_SITE_NAME === "Linley and Simpson" || process.env.GATSBY_SITE_NAME === "John Shepherd" && (props?.menu_slug?.includes("student") || (props?.searchParams?.office_department === "student" || props?.searchParams?.office_department === "Student")) ?
                                            <ImageModule ImageSrc={footer_data?.siteConfig?.Student_hub_logo ? footer_data?.siteConfig?.Student_hub_logo : footer_data?.siteConfig?.Header_Logo} altText={"Logo"} className="footer-brand student" width="150" height="55" />
                                            :
                                            <ImageModule ImageSrc={footer_data.siteConfig.Header_Bg_White_Logo ? footer_data.siteConfig.Header_Bg_White_Logo : footer_data.siteConfig.Header_Logo} altText={"Logo"} className="footer-brand" width="150" height="55" />
                                        }
                                    </div>
                                    <div className="social-links">
                                        {footer_data?.siteConfig && <SocialLinks data={footer_data?.siteConfig} />}
                                    </div>
                                </div>

                                <div className="footer-list">
                                    <FooterMenu data={footer_data?.socialLink?.footer_menu} />
                                </div>

                                <div className="bottom-info">
                                    <div className="term-condition">
                                        {footer_data?.siteConfig?.Footer_Logo && renderComponent === "true" &&
                                            <div className="footer-logo">
                                                <ImageModule ImageSrc={footer_data.siteConfig.Footer_Logo} width={footer_data.siteConfig.Footer_Logo.width} height={footer_data.siteConfig.Footer_Logo.height} loading="lazy" />
                                            </div>
                                        }
                                        <div className="site-link">
                                            <FooterText />
                                            <span className="site-text">Site by <a className="site-info" href="https://starberry.tv/" rel="noopener norefferer" target="_blank" aria-label="starberry"> <img src={STB_Logo} alt="Starberry" loading="lazy" /> </a>
                                            
                                                {process.env.GATSBY_ONETRUST_ID && (
                                                    <>&nbsp;|&nbsp; <button type="button" className="cookie_link" onClick={handleCookiesClick}>Cookies</button></>
                                                )}
                                            </span>                                            
                                        </div>
                                    </div>

                                    <ComplianceLogo />

                                    {footer_data.clientLogo?.show_on_website &&
                                        <ClientLogo data={footer_data.clientLogo} />
                                    }
                                </div>

                                {props.menu_slug &&
                                    (props.menu_slug === "search_result" ?
                                        <PopularSearch_Dynamic menu_slug={props.menu_slug} searchParams={props.searchParams} />
                                        :
                                        <PopularSearch menu_slug={props.menu_slug} popular_search={props.popular_search} />
                                    )
                                }
                            </div>

                        </Col>
                    </Row>


                </Container>
            </footer>

            {/* {process.env.GATSBY_SITE_NAME === "Linley and Simpson" &&
            <CookieConsent
                disableStyles={true}
                buttonClasses="btn btn-primary btn-link gotit"
                containerClasses="cookie-popup"
                buttonWrapperClasses="cook_txt"
                buttonText="Accept Cookies"
                contentClasses="cook_txt"
                cookieName={process.env.GATSBY_SITE_NAME}
            >   
                We have placed cookies on your device to help make this website better. By continuing, you agree to our <Link to={`/${PageLinks.privacy_policy}/`}>Privacy and Cookie Policy</Link>.
            </CookieConsent>
            } */}

            {/* {process.env.GATSBY_SITE_NAME === "Chase Evans" && (
                isDesktop ?
                    <YomdelChatScript />
                :
                    (props?.GQLPage?.layout !== "form_template" && props?.menu_slug !== "search_result") && 
                    <YomdelChatScript />
                )   
            } */}
            {/* {process.env.GATSBY_SITE_NAME === "Chase Evans" && <YomdelChatScript />} */}
        </React.Fragment>
    );
};
export default Footer;
